import store from '@/services/store.js';
import { EventBus } from '@/services/Event.js';
import RacesRegistrations from '@/components/user/dashboard/pages/races/transfer-registration/transfer-registration.vue';

export default {
    name: 'JuniorRaceTransfer',
    components: {
        RacesRegistrations
    },
    data() {
        return {
            isProcessing: true,
            juniors: [],
            juniorName: '',
            juniorId: 0
        }
    },
    computed: {
        loadedJuniorName() {
            var self = this;

            if (self.juniorName) {
                var id = self.getJuniorIdByName();

                if (id !== self.juniorId) {
                    self.changeJunior(id);
                    self.$console("Loaded data for junior - " + id + " - " + self.juniorName);
                }

                return self.user;
            }
            return '';
        },
        domain() {
            return process.env.url.oldApp;
        },
    },
    methods: {
        getJuniorIdByName() {
            var self = this;
            var juniorArray = self.juniors.filter(junior => {
                return junior.fullName === self.juniorName;
            });
            if (juniorArray.length) {
                return juniorArray[0].id;
            }
            else {
                return self.juniors[0].id;
            }
        },
        changeJunior(id) {
            this.juniorId = id;
            store.commit('setCurrentJunior', this.juniorName);
            EventBus.$emit("user-load-race-registrations", this.juniorId);
        },
        getData() {
            var self = this;
            var preloadedUser = store.getters.getUserShortInfo;//parent
            if (preloadedUser && preloadedUser.isSuccess) {
                if (preloadedUser.details.juniors && preloadedUser.details.juniors.length > 0) {
                    self.juniors = preloadedUser.details.juniors;
                    self.juniorId = self.getJuniorIdByName();

                    self.$console();
                    self.$console("Loaded juniors:");
                    self.$console({ juniors: self.juniors });
                    self.$console();
                    self.$console("Loaded data for junior - " + self.juniorId + " - " + self.juniorName);
                    
                }
                else {
                    window.history.back();
                }
                self.isProcessing = false;
            }
        },
    },
    mounted() {
        var self = this;
        var currentJun = store.getters.getCurrentJunior;
        if (currentJun) {
            self.juniorName = currentJun;
        }

        EventBus.$off("user-load-junior-race-transfer")
        EventBus.$on("user-load-junior-race-transfer", () => { self.getData(); });
        self.getData();
    }
}



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/junior/junior-race-transfer/junior-race-transfer.js